/**
 *  @class
 *  @function FreeShipping
 */
if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;
        if (amountText) {
          let remaining = minimum - total;
          amountText.innerHTML = this.formatEuro(remaining);
        }
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }
      this.style.setProperty('--percentage', percentage);
    }

    /**
     * Formatteer cents naar Nederlandse euro-notatie: 11602 → €116,02
     */
    formatEuro(cents) {
      let euros = (cents / 100).toFixed(2);
      let parts = euros.split('.');
      // Duizendtal-scheidingsteken (punt) toevoegen
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + parts[0] + ',' + parts[1];
    }
  }
  customElements.define('free-shipping', FreeShipping);
}